// Os recursos da empresa (SGP, WhatsApp não oficial, caixas de WhatsApp, IA), lidos
// uma vez por conta e compartilhados pelo menu e pelas páginas da Nexus IA.
import { computed, reactive, watch } from 'vue';
import { useAccount } from 'dashboard/composables/useAccount';
import { createNexusApi } from './api';

const porConta = reactive({});

const carrega = async accountId => {
  if (!accountId || accountId in porConta) return;
  porConta[accountId] = null;
  try {
    const { data } = await createNexusApi(accountId).recursos();
    porConta[accountId] = data;
  } catch {
    porConta[accountId] = {};
  }
};

// Para código Options API do core (lido dentro de um computed, é reativo):
// null enquanto carrega.
export const recursosDe = accountId => {
  carrega(accountId);
  return porConta[accountId] ?? null;
};

// => computed: null enquanto carrega, depois { sgp, whatsapp, whatsapp_caixas, ... }.
export const useRecursos = () => {
  const { accountId } = useAccount();
  watch(accountId, carrega, { immediate: true });
  return computed(() => porConta[accountId.value] ?? null);
};

// As seções da Nexus IA: rota, recurso que a libera e o texto do menu.
export const SECOES = [
  { id: 'TEIA', rota: 'neuxs_nexus_teia', recurso: 'ia' },
  { id: 'DISPAROS', rota: 'neuxs_nexus_disparos', recurso: 'sgp' },
  { id: 'GATEWAY', rota: 'neuxs_nexus_gateway', recurso: 'sgp' },
  { id: 'MANUTENCAO', rota: 'neuxs_nexus_manutencao', recurso: 'sgp' },
  { id: 'USO', rota: 'neuxs_nexus_uso', recurso: 'whatsapp_caixas' },
];

export const secoesLiberadas = recursos =>
  recursos ? SECOES.filter(secao => recursos[secao.recurso]) : [];
